<template>
    <div>
        <v-layout wrap justify-center py-10>
            <v-flex xs9>
              <v-card elevation="0">
                <v-layout wrap>
                  <v-flex xs12 text-justify>
        
              
                      <!-- <span style="font-family:poppinsbold; text-align: justify; font-size: 20px;">{{ productspec.productName }}</span><br> -->
                      <span style="font-family:poppinsregular; text-align: justify; font-size: 16px;">{{ productspec.specificationDetails }}</span>
                    <!-- Table for Product Specifications -->
                    <!-- <v-simple-table
                    style="border: 1px solid black; border-collapse: collapse;"
                  >
                  
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" style="background-color: #004d40; color: white; padding: 12px; font-family: poppinssemibold;border: 1px solid black; 
                         border-collapse: collapse;"> 
                              SPECIFICATION
                            </th>
                            <th class="text-left" style="background-color: #004d40; color: white; padding: 12px; font-family: poppinssemibold;border: 1px solid black; 
                         border-collapse: collapse;"> 
                              DETAILS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Product Name</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Organic Forest Honey</td>
                          </tr>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Source</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Collected from wild bee colonies in organic-certified forests</td>
                          </tr>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Ingredients</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Raw organic forest honey (no additives or preservatives)</td>
                          </tr>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Flavor Profile</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Rich, earthy taste with floral undertones</td>
                          </tr>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Color</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px; border-bottom: 1px solid #e0e0e0;border: 1px solid black; 
                         border-collapse: collapse;"> Dark amber to golden brown</td>
                          </tr>
                          <tr>
                            <td style="text-align: left;font-family: poppinsregular; padding: 10px;border: 1px solid black; 
                         border-collapse: collapse;"> Health Benefits</td>
                            <td style="text-align: left; font-family: poppinsregular; padding: 10px;border: 1px solid black; 
                         border-collapse: collapse;"> 
                              - Boosts immunity with antioxidants <br>
                              - Natural energy booster and cough remedy <br>
                              - Promotes digestion and gut health
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table> -->
        
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
    </div>
</template>


<script>
import axios from "axios";
export default {
  
  data() {
    return {
      tab: 0, // To control the active tab
      rate: 4, // Example rating value
      dialog: false, // To control the review dialog
      productspec:[],
      //productdes:[],
    };
  },
  beforeMount() {
    this.productSpecDes();
  },
  methods:{
    productSpecDes() {
      this.appLoading = true;
      // var headers1 = {};
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/product/specificationAndDescription",
        method: "POST",
        data: {
          productId: this.$route.query.id,
        
          id: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
        // headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.productspec = response.data.specifications;
          //this.productdes = response.data.descriptions;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
  }
};
</script>

<style scoped>
/* Add any custom styles you may need */
</style>
